// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XpaFK{display:flex;flex-direction:column;gap:8px}.qpxf9{display:flex;justify-content:space-between;align-items:center;gap:16px}.MIQC3{display:flex;gap:24px;align-items:flex-start;margin-top:16px}.hSKg5{flex:1;display:flex;flex-direction:column;gap:24px}.cqaBt{margin:0}.bub_n{display:inline-flex;align-items:center;cursor:help}.gEZ7o{padding-left:28px;margin-top:-8px}.i8x0M{display:flex;justify-content:center}.eYsBl{align-self:flex-start;margin-top:0;margin-right:14px}.N1Ezm{display:flex;align-items:center;justify-content:center;min-height:240px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContentWrapper": `XpaFK`,
	"headerRow": `qpxf9`,
	"sectionsRow": `MIQC3`,
	"section": `hSKg5`,
	"sectionTitle": `cqaBt`,
	"tooltipIcon": `bub_n`,
	"termsOfServiceIndent": `gEZ7o`,
	"sendButtonRow": `i8x0M`,
	"emailContentAdornment": `eYsBl`,
	"loadingWrapper": `N1Ezm`
};
export default ___CSS_LOADER_EXPORT___;
